import { render } from "./loader-display.component.vue?vue&type=template&id=d4e6fbd4&scoped=true&ts=true"
import script from "./loader-display.component.vue?vue&type=script&lang=ts"
export * from "./loader-display.component.vue?vue&type=script&lang=ts"

import "./loader-display.component.vue?vue&type=style&index=0&id=d4e6fbd4&scoped=true&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4e6fbd4"]])

export default __exports__